import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import {
  Avatar,
  Box,
  Button,
  ButtonGroup,
  Divider,
  List,
  ListItem,
  Typography,
} from "@material-ui/core";
import { client } from "../../service/ApolloClient/ApolloClient";
import { ErrorToast, SuccessToast } from "../../hoc/ToastNotify/ToastNotify";
import { MUTATION_REMOVE_ATTACHMENT } from "../../service/ApolloClient/ApolloMutation";
const isImageUrl = (url) => /\.(jpg|jpeg|png|gif|webp|svg|bmp|ico)(\?.*)?$/i.test(url);

class FileList extends React.Component {
  constructor(props) {
    super(props);
  }

  handleRemoveFile = (file) => {
    client
      .mutate({
        mutation: MUTATION_REMOVE_ATTACHMENT,
        variables: {
          id: file.id,
        },
      })
      .then((res) => {
        SuccessToast("با موفقیت حذف گردید");
        this.props.handleReload();
      })
      .catch((err) => {
        ErrorToast("قادر به حذف نمی باشد");
      });
  };

  render() {
    const { files } = this.props;

    return (
      <Wrapper>
        {files && files.length > 0 ? (
          <List component="nav">
            {files.map((file) => {
              return (
                <Wrapper key={file.id}>
                  <ListItem p={1}>
                    <Box display={"flex"} style={{ width: "100%" }}>
                      {isImageUrl(file.url) ? (
                        <Box p={1}>
                          <Avatar
                            src={file.url}
                            variant="square"
                            sizes={"35px"}
                          />
                        </Box>
                      ) : null}
                      <Box flexGrow={1} p={1}>
                        {file.name}
                      </Box>
                      <Box p={1} pt={2}>
                        {file.updated_at}
                      </Box>
                      <Box p={1}>
                        <ButtonGroup>
                          <Button size={"small"}>
                            <a href={file.url} target={"_blank"}>
                              مشاهده فایل
                            </a>
                          </Button>
                          <Button
                            size={"small"}
                            color={"secondary"}
                            onClick={(e) => this.handleRemoveFile(file)}
                          >
                            حذف فایل
                          </Button>
                        </ButtonGroup>
                      </Box>
                    </Box>
                  </ListItem>
                  <Divider />
                </Wrapper>
              );
            })}
          </List>
        ) : (
          <Typography>فایل برای نمایش وجود ندارد</Typography>
        )}
      </Wrapper>
    );
  }
}

export default FileList;
